module.exports = __webpack_public_path__ + "static/media/sammy_linguagens.bc3d62a6.png";